export const CREATE_BOOKING_REQUEST = 'booking/CREATE_BOOKING_REQUEST';
export const CREATE_BOOKING_SUCCESS = 'booking/CREATE_BOOKING_SUCCESS';
export const CREATE_BOOKING_FAILURE = 'booking/CREATE_BOOKING_FAILURE';

export const INITIATE_PAYMENT_REQUEST = 'booking/INITIATE_PAYMENT_REQUEST';
export const INITIATE_PAYMENT_SUCCESS = 'booking/INITIATE_PAYMENT_SUCCESS';
export const INITIATE_PAYMENT_FAILURE = 'booking/INITIATE_PAYMENT_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/booking/actionTypes.js